// https://react-hook-form.com/docs/useform/register

// all of these are meant to be passed to the register function of RHF.
// e.g. `register('myFieldName', registerOptions)`
// where registerOptions is an object with any of these keys
// and values that match the type of the key
// (e.g. `required: true`, `pattern: { value: /regex/, message: 'error message' }`)

// these are meant to be spread onto the input element to be
// registered with RHF in LabelWrapper.
// i.e. a `pattern`
const VALIDATION_REQUIRED = { required: "This field is required." };
const VALIDATION_PATTERN_EMAIL = {
	pattern: {
		value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
		message: "Invalid email address"
	}
};
const VALIDATION_PATTERN_PHONE = {
	pattern: {
		// should contain 10 digits and optionally dashes
		value: /^\d{3}-?\d{3}-?\d{4}$/,
		message: "Invalid phone number"
	}
};

const VALIDATION_PATTERN_DATE = {
	pattern: {
		// expected format is MM/DD/YYYY
		value: /^(0[1-9]|1[012])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/,
		message: "Please enter a valid move in date"
	}
};

export {
	VALIDATION_REQUIRED,
	VALIDATION_PATTERN_EMAIL,
	VALIDATION_PATTERN_PHONE,
	VALIDATION_PATTERN_DATE
};
